export const categories = [
  { slug: "entertainment", name: "娱乐综艺", icon: "ri-movie-2-line", count: 128 },
  { slug: "education", name: "教育学习", icon: "ri-book-open-line", count: 95 },
  { slug: "technology", name: "科技数码", icon: "ri-smartphone-line", count: 76 },
  { slug: "lifestyle", name: "生活美食", icon: "ri-restaurant-line", count: 84 },
  { slug: "sports", name: "体育竞技", icon: "ri-basketball-line", count: 62 },
  { slug: "music", name: "音乐舞蹈", icon: "ri-music-line", count: 110 },
  { slug: "gaming", name: "游戏动漫", icon: "ri-gamepad-line", count: 93 },
  { slug: "documentary", name: "纪录纪实", icon: "ri-film-line", count: 45 },
  { slug: "fashion", name: "时尚美妆", icon: "ri-palette-line", count: 58 },
  { slug: "kids", name: "少儿乐园", icon: "ri-emotion-happy-line", count: 37 },
];